import { uniq } from "lodash";
import { convertToSnakeCase } from "../../../utils/helpers/text";
import {
  agGridAutoGroupfieldName,
  DEFAULT_FILTER,
} from "../../../constants";
import { filterKeyMapping } from "../../DLabGrid/dLabGridConstant";
import DATA_MODEL_TABLE from "../../../utils/constants/dataModelTable";

export const buildAgGridFilterObj = (currentState) => {
  const obj = {};
  const handledSnakeKeys = new Set();
  for (const key in DEFAULT_FILTER.filterDefinition) {
    const snakeKey = convertToSnakeCase(filterKeyMapping[key] || key);
    handledSnakeKeys.add(snakeKey);
    if (currentState[snakeKey] === undefined) {
      obj[key] = DEFAULT_FILTER.filterDefinition[key];
    } else if (currentState[snakeKey]?.filterType === "set") {
      let values = currentState[snakeKey]?.values;
      if (
        filterKeyMapping[key] === DATA_MODEL_TABLE?.equipmentModel?.key ||
        key === DATA_MODEL_TABLE?.equipmentModel?.key
      ) {
        if (Object?.keys(currentState)?.includes(agGridAutoGroupfieldName)) {
          values = uniq([...values, ...currentState[agGridAutoGroupfieldName]?.values]);
        }
      }
      obj[key] = values;
    } else {
      obj[key] = currentState[snakeKey];
    }
  }
  for (const stateKey in currentState) {
    if (!handledSnakeKeys.has(stateKey) && stateKey !== agGridAutoGroupfieldName) {
      obj[stateKey] = currentState[stateKey]?.filterType === "set"
        ? currentState[stateKey]?.values
        : currentState[stateKey];
    }
  }
  return obj;
};
